import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService, EnvironmentModel} from '@cas-hub/acabim-common-client';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class WorkOrderService extends ApiService {

    constructor(protected client: HttpClient,
                protected environment: EnvironmentModel) {
        super(client, environment);
    }

    protected controller = '';

    public cancelWorkOrders(workOrderId: string): Observable<any> {
        return this.client.post(this.url('fm/work-order/' + workOrderId + '/status/7', true), {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }


}
